import axios from '@/utils/request';
const prefix = 'esun/v3';

export const query = (order_no) => axios.post(`${prefix}/query`, { OrderNo: order_no });

export const cancel = (order_no) => axios.post(`${prefix}/cancel`, { OrderNo: order_no });

export const refund = (order_no, order_amount) => axios.post(`${prefix}/refund`, { OrderNo: order_no, RefundOrderAmount: order_amount });
